import React from 'react'
import { Link } from 'react-router-dom'

export default function PaymentFeatureTwo() {
    return (
        <section className="payment-feature-img pt-200">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5">
                        <div className="payment-feature-img-left mb-5 mb-lg-0">
                            <h2 className="mb-4">
                                We grow your company with sustainable and profitable strategy
                            </h2>
                            <p className="mb-4">
                                Navigate today’s volatile markets, has a strong focus on quality and delivers insights to succeed
                            </p>
                            <Link to="/contact-us" className="btn-gradient-sqr">Contact us</Link>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div
                            className="payment-feature-img-right text-center position-relative mt-5 mt-lg-0"
                        >
                            <div className="payment-feature-mockup position-relative">
                                <img
                                    src="assets/img/payment-mock.png"
                                    className="img-fluid"
                                    alt="Mocup"
                                />
                            </div>
                            <div className="payment-feture-shape">
                                <img
                                    src="/assets/img/payment-ft-2.png"
                                    className="shape-one shadow-lg"
                                    alt="Tax"
                                />
                                <img
                                    src="/assets/img/payment-ft.png"
                                    className="shape-two shadow-lg"
                                    alt="Tax"
                                />
                                <img
                                    src="/assets/img/p-dot.png"
                                    className="shape-three"
                                    alt="dot"
                                />
                                <img
                                    src="assets/img/blue-shape.png"
                                    className="shape-four"
                                    alt="shape"
                                />
                                <img
                                    src="assets/img/pink-circle.png"
                                    className="shape-five"
                                    alt="shape"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
